import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService, ProjectService,} from '../../_services/index';
import {Project} from "../../_models";
import {saveAs as importedSaveAs} from "file-saver";
import {PolicyService} from "../../_services/policy.service";

@Component({
    standalone: false,
  selector: 'export-policy-component',
  templateUrl: 'exportPolicy.component.html'
})

export class ExportPolicyComponent implements OnInit {
  projectId: number = 0;
  projects: Project[];

  constructor(
    public dialogRef: MatDialogRef<ExportPolicyComponent>,
    public projectService: ProjectService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public policyService: PolicyService,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public authenticationService: AuthenticationService) {

  }

  ngOnInit() {
    this.projectService.getAllShort()
      .subscribe(p => this.projects = p);

  }

  generate(): void {
    this.dialogRef.close();

    this.policyService.exportPolicy(this.data.policyId, this.projectId).subscribe(blob => {
        importedSaveAs(new Blob([blob]), 'Policy.docx');
      },
      error => {
        const errorMessage = 'Error during exporting policy';
        this.alertService.error(errorMessage);
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
